import { render, staticRenderFns } from "./SubmitForm.vue?vue&type=template&id=5f6e6d27&"
import script from "./SubmitForm.vue?vue&type=script&lang=js&"
export * from "./SubmitForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/live/admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5f6e6d27')) {
      api.createRecord('5f6e6d27', component.options)
    } else {
      api.reload('5f6e6d27', component.options)
    }
    module.hot.accept("./SubmitForm.vue?vue&type=template&id=5f6e6d27&", function () {
      api.rerender('5f6e6d27', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/bespoke/pages/HotelBatchLoader/Components/SubmitForm.vue"
export default component.exports